"use strict";

import $ from "jquery";

const defaultOptions = {
    center: {lat: 47.836249, lng: 13.0615383},
    zoom: 12
};

// options -> mapObj
export default function initMap({
    element,
    mapOptions = {},
    mapLayer = {},
    pois = [],
    poiStyles = null,
    infoBoxOptions = {},
    clustering = true,
    clusteringOptions = {},
    onActivateMarker,
    onDeactivateMarker,
    leaflet = L, //global leaflet instance
    } = {}) {
    mapOptions = {...defaultOptions, ...mapOptions};

    let map = leaflet.map(element, mapOptions).setView([mapOptions.center.lat, mapOptions.center.lng], mapOptions.zoom);

    if (!_config.mapAccessToken) {
        console.error('map access key is not set. Please set _config.mapAccessToken');
    }

    mapLayer.addTo(map);

    let clusteringPromise;
    if (clustering) {
        clusteringPromise = import("leaflet.markercluster").then(function () {
            return leaflet.markerClusterGroup(mapObj.clusteringOptions);
        });
    }

    const mapObj = {
        map,
        marker: [],
        activeMarker: null,
        mapOptions,
        mapLayer,
        poiStyles,
        infoBoxOptions,
        clustering,
        clusteringPromise,
        clusteringOptions,
        onActivateMarker,
        onDeactivateMarker,
        leaflet
    };

    $(element).data('leaflet-map', mapObj);

    return mapObj;
}


/* General */
export function getMapObj($element) {
    if (!($element instanceof jQuery)) {
        $element = $($element);
    }

    return $element.data('leaflet-map');
}


/* Marker */
export function setMarker(mapObj, pois) {
    removeAllMarker(mapObj);
    addMarker(mapObj, pois);

    centerMap(mapObj);
}

function addMarker(mapObj, pois) {
    pois.map(poi => {
        let poiStyle;


        if (poi.poiStyle) {
            if (mapObj.poiStyles) {
                if (mapObj.poiStyles[poi.poiStyle]) {
                    poiStyle = mapObj.poiStyles[poi.poiStyle];
                } else {
                    poiStyle = mapObj.poiStyles.default;
                    console.error(`Could not find poi style '${poi.poiStyle}' in `, mapObj.poiStyles);
                }
            } else {
                console.error('Poi styles ar not set');
            }
        } else if (mapObj.poiStyles && mapObj.poiStyles.default) {
            poiStyle = mapObj.poiStyles.default;
        }


        let marker = mapObj.leaflet.marker([poi.lat, poi.lng],{icon: poiStyle ? poiStyle.default : null});
        marker.poiStyle = poiStyle;
        marker.dataId = poi.id;
        marker.detailInfo = poi.detailInfo;
        marker.detailInfoBoxUrl = poi.detailInfoBoxUrl;

        if (mapObj.onActivateMarker && mapObj.onDeactivateMarker) {
            marker.on('click', function () {
                if (mapObj.activeMarker === marker) {
                    deactivateMarker(marker, mapObj);
                } else {
                    activateMarker(marker, mapObj);
                }
            });
        }
        mapObj.marker.push(marker);

        if (!mapObj.clustering) {
            marker.addTo(mapObj.map);
        }
    });

    if (mapObj.clustering) {
        mapObj.clusteringPromise.then(function (cluster) {
            $.each(mapObj.marker, function (index, marker) {
                cluster.addLayer(marker);
            });

            mapObj.map.addLayer(cluster);
            // cluster.on('animationend', function () {
            //     console.log('animationend');
            //     console.log(cluster.getAllChildMarkers());
            // });
        });
    }
}

export function removeAllMarker(mapObj) {
    if (mapObj.onDeactivateMarker) {
        mapObj.marker.forEach(x => mapObj.onDeactivateMarker(x, mapObj));
    }

    $.each(mapObj.marker, function (index, marker) {
        mapObj.map.removeLayer(marker);
    });

    mapObj.marker = [];

    if (mapObj.clustering) {
        mapObj.clusteringPromise.then(function (cluster){
            cluster.clearLayers();
            mapObj.map.removeLayer(cluster)
        });
    }
}


/* Active marker state */
export function activateMarker(marker, mapObj) {
    if (mapObj.activeMarker) {
        deactivateMarker(mapObj.activeMarker, mapObj);
    }

    mapObj.onActivateMarker(marker, mapObj);
    mapObj.activeMarker = marker;

    setActiveMarkerStyle(marker, mapObj);

    mapObj.map.setView(marker.getLatLng());
}

export function deactivateMarker(marker, mapObj) {
    mapObj.onDeactivateMarker(mapObj.activeMarker, mapObj);
    mapObj.activeMarker = null;

    setDefaultMarkerStyle(marker, mapObj);
}

export function setActiveMarkerStyle(marker, mapObj) {
    if (marker.poiStyle) {
        marker.setIcon(marker.poiStyle.active);
    }
}

export function setDefaultMarkerStyle(marker, mapObj) {
    if (marker.poiStyle) {
        marker.setIcon(marker.poiStyle.default);
    }
}

export function centerMap(mapObj) {
    scrollToMarkers(mapObj.marker, mapObj);
}

export function scrollToMarkers (markers, mapObj) {
    let latLngs = markers.map(marker => marker._latlng);

    // Zoom/center map to fit all marker
    if (latLngs.length === 0) {
        mapObj.map.panTo(mapObj.mapOptions.center);
    } else if (latLngs.length === 1) {
        mapObj.map.fitBounds(latLngs, {maxZoom: mapObj.mapOptions.zoom});
    } else {
        mapObj.map.fitBounds(latLngs, {padding: [20, 20]});
    }
}

/* Info boxes */
export function showInfoBoxByMarker(marker, content, mapObj) {
    if(!marker._popup) {
        marker.bindPopup(content, mapObj.infoBoxOptions).openPopup();
    }

    return marker._popup;
}